
export class InserisciScadenze {
    data: number;
    id: string;

    constructor(termine){
        this.data = termine.data;
        this.id = termine.id ? termine.id : null;
    }
}